jQuery( function($){

    var $cookies = $('.js-caja-cookies');
    var $btn = $('.js-caja-cookies__btn');
    var cookie_name = 'website_accept_cookies';

    if( !Cookies.get( cookie_name )){
        $cookies.fadeIn();
    }

    $btn.click( function(){
        Cookies.set( cookie_name, true, { expires: 365 });
        $cookies.fadeOut();
    });

});
